import { Dropdown } from "react-bootstrap";
import { CategoryResetTypeList } from "../../../constants/category.constants";
import { CustomDeleteModal } from "../../DeleteModal/DeleteModal";
import { useState } from "react";
import { useEntity } from "../../../hooks/use-entity.hook";
import { Flaggers } from "../../../common/store/flaggers/flaggers.enum";
import { FlaggersMethods } from "../../../common/store/flaggers/flaggers.methods";
import useActions from "../../../hooks/service-actions.hook";
import { convertToDDMMYYYY } from "./MspAttackSurface";
import useLoaders from "../../../hooks/use-loaders.hook";
import { Loaders } from "../../../common/store/loaders/loaders.enum";
import { CompanyTechSpendEffectActions } from "../../../common/services/company-techspend/company-techspend.service";

const ResetCategoryDropdown = ({ clientId, selectedDateFilter, resetForSO = false, onSuccess = () => {} }) => {
  const { resetCategories } = useActions(CompanyTechSpendEffectActions);
  const { entityData: resetModalData, setEntityData: setResetModalData } = useEntity({ entityType: Flaggers.ResetCategoryFlagger });
  const { isLoading: isResetCategoryLoading } = useLoaders({ loaders: [Loaders.ResetCategoryLoader] });

  const handleResetCategory = (item) => {
    setResetModalData({
      showModal: true,
      deleteType: item.value,
      deleteParams: item.message,
    }, FlaggersMethods.UpdateFlagger);
  }

  return (
    <>
      <ResetDropdown onOptionClick={handleResetCategory}>
        <div
          className="d-flex align-items-center f-grey pointer bg-hover-grey"
          id="rename-div"
          style={{ padding: '4px 12px' }}
        >
          <div>Reset</div>
          <span className="mr-3"></span>
          <div className="d-flex justify-content-end w-100 ml-5">
            <img
              alt=""
              src="/images/attack-surface/chevron-right.svg"
              style={{ marginRight: '6px' }}
            />
          </div>
        </div>
      </ResetDropdown>
      <CustomDeleteModal
        show={resetModalData?.showModal}
        hideModal={() => {
          setResetModalData(null, FlaggersMethods.UpdateFlagger);
        }}
        deleteFunction={(e) => {
          resetCategories({
            clientId,
            resetType: resetModalData.deleteType,
            resetForSO,
            fromDate: selectedDateFilter ? convertToDDMMYYYY(selectedDateFilter?.startDate) : undefined,
            toDate: selectedDateFilter ? convertToDDMMYYYY(selectedDateFilter?.endDate) : undefined,
            callback: onSuccess,
          });
        }}
        deleteBodyText={resetModalData?.deleteParams}
        deleteButtonText={"Confirm"}
        isLoading={isResetCategoryLoading}
        processingText="Resetting..."
      />
    </>
  )
}

export default ResetCategoryDropdown;

const ResetDropdown = ({
  children,
  onOptionClick
}) => {
  return (
    <Dropdown
      className="transparennt-wrapper-dropdown my-dropdown w-100"
    >
      <Dropdown.Toggle className="w-100">
        {children}
      </Dropdown.Toggle>
      <Dropdown.Menu 
        className="menu tax-type-menu overlap-toggle"
        style={{ 
          width: 'fit-content', 
          padding: '8px 4px',
        }}
        renderOnMount
      >
        {CategoryResetTypeList.map((item) => (
         <div
            key={`tax-${item.value}`}
            className="integration-item bg-hover-grey d-flex pointer"
            onClick={() => {
              onOptionClick(item);
            }}
          >
            <span className="item py-1 f-grey ml-2">{item.label}</span>
          </div>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}